import { Stack, SvgIconProps } from '@mui/material';
import React from 'react';

import Devices from '../../assets/icons/Devices';
import Snackbar from '../../components/Snackbar';
import colors from '../../constants/colors';
import { useSnackbarsContext } from '../../store/SnackbarProvider';
import { editAccessibilityButtonStyles } from '../../utils/helpers';

interface SplitviewProps {
  Icon?: React.ReactElement<SvgIconProps>;
}

const SplitView = ({
  children,
  Icon = <Devices />,
}: React.PropsWithChildren<SplitviewProps>) => {
  const { state } = useSnackbarsContext();
  editAccessibilityButtonStyles();

  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: "space-around",
        flex: 1
      }}>
      <Stack
        direction="column"
        sx={{
          justifyContent: "center",
          alignItems: "center",
          flex: 1,

          display: {
            mobile: 'none',
            tablet: 'none',
            desktop: 'flex',
          }
        }}>
        {Icon}
      </Stack>
      <Stack
        data-testid="manageYourInsurance"
        direction="column"
        sx={{
          backgroundColor: colors.csaaGray,
          flex: 1,
          py: { mobile: 3, tablet: 15, desktop: 0 },
          mt: { desktop: -30 },
        }}
      >
        <Stack
          spacing={1.5}
          sx={{
            justifyContent: "center",
            px: { mobile: 2, tablet: 3, desktop: 7 },
            py: 1.5,
            mt: { desktop: 30 }
          }}>
          {state.snackbars.length > 0 &&
            state.snackbars.map((snack, idx) => (
              <Snackbar
                key={snack.key}
                {...snack}
                id={snack.key!}
                dataTestId={`${snack.key}-${idx}`}
              />
            ))}
        </Stack>
        {children}
      </Stack>
    </Stack>
  );
};

export default SplitView;
